import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE;

/** GET /v{version}/subscriptions/availableKeys */
export default function getAvailableSubscriptionKeys(brokerageId) {
  return axios.get(`${API_BASE}subscriptions/availableKeys`, {
    params: { brokerageId: Number(brokerageId) }
  });
}
